export const ENGAGEMENT_MODELS = {
    fixed_price: 'Fixed Price',
    time_and_material: 'Time & Material',
    dedicated_team: 'Dedicated Team',
    staff_augmentation: 'Staff Augmentation',
    monthly_retainer: 'Monthly Retainer',
    subscription_license: 'Subscription / License',
    revenue_share: 'Revenue Share',
    joint_venture_partnership: 'Joint Venture / Partnership',
    tbd: 'TBD',
};

export const ENGAGEMENT_MODEL_ORDER = Object.keys(ENGAGEMENT_MODELS);

export function getEngagementModelLabel(key) {
    return ENGAGEMENT_MODELS[key] || key;
}
